// extracted by mini-css-extract-plugin
export default {"section":"SectionProjects_section__JmtEO","container":"SectionProjects_container__Q4MDI"};